import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { SearchLibComponent } from './components/search-lib/search-lib.component';
import { LibBrowserComponent } from './components/lib-browser/lib-browser.component';
import { AssetSpecificationComponent } from './components/asset-specification/asset-specification.component';
import { AssetInformationComponent } from './components/asset-information/asset-information.component';

// import '../assets/dist/shui.min.js';
import { PersonalBrowserComponent } from './components/personal-browser/personal-browser.component';
import { CommentsComponent } from './components/comments/comments.component';
import { PipeModule } from 'src/app/shared/pipe/pipe.module';
import { LibraryBrowserComponent } from 'src/app/modules/assetModule/components/library-browser/library-browser.component';
import { HttpService } from 'src/app/modules/assetModule/shared/services/http.service';
import { ContextMenuComponent } from 'src/app/modules/assetModule/components/context-menu/context-menu.component';
import { UploadAssetComponent } from 'src/app/modules/assetModule/components/upload-asset/upload-asset.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { RouterModule } from '@angular/router';
import { ThreeAssetRenderComponent } from './components/three-asset-render/three-asset-render.component';
// import { ProductStatusPipe } from './Shared/pipe/product-status.pipe';
// import { ProfileComponent } from './profile/profile.component';
import { DragAndDropModule } from 'angular-draggable-droppable';
import { LastVisitedComponent } from './components/last-visited/last-visited.component';
import { UploadNewAssetComponent } from './components/upload-new-asset/upload-new-asset.component';
import { SharedModule } from 'src/app/shared/components/shared.modules';
import { GalleryModule } from 'ng-gallery';
import { TreeModule } from '@odymaui/angular-tree-component';


let components = [
  SearchLibComponent,
  LibBrowserComponent,
  AssetSpecificationComponent,
  AssetInformationComponent,
  PersonalBrowserComponent,
  CommentsComponent,
  LibraryBrowserComponent,
  ContextMenuComponent,
  UploadAssetComponent,
  ThreeAssetRenderComponent,
  LastVisitedComponent,
  UploadNewAssetComponent
];

@NgModule({
  declarations: components,
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    RouterModule,
    PipeModule,
    TreeModule,
    HttpClientModule,
    NgxFileDropModule,
    ReactiveFormsModule,
    DragAndDropModule,
    SharedModule,
    GalleryModule
  ],
  providers: [HttpService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: components
})
export class AssetModule { }
